import { Component } from "react";

import { trackEvent, EventNames } from 'utils/mixpanel';
import { Button } from 'react-bootstrap';
import { ASSISTANT_RESPONSE } from "utils/constants";
import { generic_post_api } from "api/generic_api";

const formatPhone = (phoneNumber) => {

    if (!phoneNumber) { return ""; }

    if (phoneNumber.length === 10) {
        return phoneNumber.substring(0, 3) + '-' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6, 10);
    }

    if (phoneNumber.length === 11) {
        return phoneNumber.substring(0, 1) + '-' + phoneNumber.substring(1, 4) + '-' + phoneNumber.substring(4, 7) + '-' + phoneNumber.substring(7, 11);
    }
}

class Assistant extends Component {
    constructor(props) {
        let from_number = null;
        let idx = null;

        let urlParams = new URLSearchParams(window.location.search);
        from_number = urlParams.get('from_number');
        idx = urlParams.get('idx');

        super(props);
        this.state = {
            from_number: from_number,
            idx: idx,
            message: "",
            complete: false,
        };
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'contact_index'});
        document.title = "Reputable vendors from your real estate professional";
    }

    submit()
    {   
        let request = {
            idx: this.state.idx,
            from_number: this.state.from_number,
            message: this.state.message,
        }
        generic_post_api(request, ASSISTANT_RESPONSE)
        .then(
            (result) => {
                if (result.status === 200) { 
                    this.setState({complete: true});
                }
            }
             
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });
    }

    render() {
        const {from_number, message, complete} = this.state;
        
        const setMessage = (message_type, value) => {
            
            if (message_type === 'call' && value) {
                this.setState({
                    message: 'Hi, I have received your request and will call you shortly.',
                    
                });
            }
            else if (message_type === 'pass' && value) {
                this.setState({
                    message: 'Hi, We have reviewed your request. Unfortunately, we are over-extended with existing projects at the moment and are not accepting new projects. Thank you for reaching out and we hope to work with you in the future.',
                    
                });
            }
            else if (message_type === 'custom' && value) {
                this.setState({message: ""});
            }
        }

        return(
                <>
                { !complete ? 
                        <div class="container mt-5">
                            <div class="row">
                                <div class="col fw-bold">Respond to {formatPhone(from_number)}</div>
                            </div>
                            <div class="row mt-4">
                                <div class="col">Pick from a quick response or type your own response</div>
                            </div>
                            <div class="mt-2 row">
                                <div class='col-auto pe-0'> <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1"  
                                    onChange={ (e) => setMessage('call', e.currentTarget.checked) }/></div>
                                <div class='col'>Hi, I have reviewed your request and will call you shortly.</div>
            
                            </div>
                            <div class="row mt-2">
                                <div class='col-auto pe-0'> <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1"  
                                    onChange={ (e) => setMessage('pass', e.currentTarget.checked) }/></div>
                                <div class='col'>
                                    Hi, We have reviewed your request but unfortunately, we are over-extended with existing projects at the moment. We are not able 
                                    to take your project at this time. Thank you for reaching out and we hope to work with you in the future.
                                </div>
                                
                            </div>
                            <div class="row mt-2">
                                <div class='col-auto pe-0'> 
                                    <input class="form-check-input" type="radio" name="radioDefault" id="radioDefault1"  
                                        onChange={ (e) => setMessage('custom', e.currentTarget.checked) }/>
                                </div>
                                <div class='col'> Type your own message.</div>
   
                                {/* <textarea class="form-control mt-1" rows="4" value={message} placeholder="text" style={{'font-size': '15px' }}onChange={(e) => this.setState({message: e.target.value})}/>  */}
                            </div>
                            <div class="row mt-1">
                                <div class='col'>
                                    <textarea class="form-control mt-1" rows="4" value={message} placeholder="text" style={{'font-size': '15px' }}onChange={(e) => this.setState({message: e.target.value})}/> 
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col text-center">
                                    <Button variant="primary" onClick={this.submit} >Submit response <i class="fa-regular fa-paper-plane"></i></Button>
                                </div>
                            </div>
                        </div>
                    :
                    <div class="container mt-5">
                        <div class="row">
                            <div class="col fw-bold">Your response to the client was sent.</div>
                        </div>
                    </div>
                }
               </>
        )
    }
}

export default Assistant;